// @flow

class User {
  code: string;
  externalCode: string;
  name: string;
  email: string;
  phone: string;
  isRetail: boolean;
  billingName: string
  billingEmail: string
  billingLegalIDType: string
  billingLegalID: string
  billingAddress: string
  hasTerms: boolean
  privacyPolicy: boolean
  marketingCampaign: boolean

  static parse(raw: any): ?User {
    if (raw) {
      if (typeof (raw) === 'string') {
        return User.parse(JSON.parse(raw));
      }
      let user: User = new User();
      user.code = raw.code;
      user.externalCode = raw.externalCode;
      user.name = raw.name;
      user.email = raw.email;
      user.phone = raw.phone;
      user.isRetail = raw.isRetail;
      user.billingName = raw.billingName;
      user.billingEmail = raw.billingEmail;
      user.billingLegalIDType = raw.billingLegalIDType;
      user.billingLegalID = raw.billingLegalID;
      user.billingAddress = raw.billingAddress;
      user.hasTerms = !!raw.hasTerms;
      user.privacyPolicy = !!raw.privacyPolicy;
      user.marketingCampaign = !!raw.marketingCampaign;
      return user;
    }
    return null;
  }
}

export default User;
